// Copyright 2022-2023 @Polkasafe/polkaSafe-ui authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
export const DEFAULT_MULTISIG_NAME = 'Untitled Multisig';
export const DEFAULT_USER_ADDRESS_NAME = 'My Address';
export const DEFAULT_ADDRESS_NAME = 'Untitled Address';